import React from 'react';
export const MsgContext = React.createContext(null);